export const config = {
	apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
	authDomain: "pizza-politano.firebaseapp.com",
	projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
	storageBucket: "pizza-politano.appspot.com",
	messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
	appId: process.env.REACT_APP_FIREBASE_APP_ID,
	measurementId: "G-ZBKM18V1D6"
  };
  